import React from "react";
import ChildOrNull from "~/common/ChildOrNull";
import connectUserAndChat from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import WebPlusShippingAdLoggedOut from "~/home/Homepage/WebPlusShippingAdLoggedOut";
import { useHomePageData } from "./utilities";
interface Props {
  user: User;
}
const SignupAndSaveBanner = connectUserAndChat(({
  user
}: Props): JSX.Element => {
  const isCarousel = !!useHomePageData().carousel;
  return <ChildOrNull condition={!user.hasWebPlus}>
        <div className={`pt-0 ${isCarousel ? "mb-6 xl:mb-10" : "pb-4"}`} data-testid="hp-plus-banner">
          <div id="cio-plusday-plusad" className="container">
            <WebPlusShippingAdLoggedOut />
          </div>
        </div>
      </ChildOrNull>;
});
export default SignupAndSaveBanner;